import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";
import NotFound from "../../../../components/notfound/NotFound";
import IncrementRow from "./IncrementRow";
import DecrementRow from "./DecrementRow";

const Rows = ({ title, color, bgColor, data, RowComponent }) => (
    <>
        <TableRow sx={{ bgcolor: bgColor }}>
            <TableCell colSpan={4} sx={{ textAlign: "center", color: color }}>
                {title}
            </TableCell>
        </TableRow>
        {data.length < 1 ? (
            <TableRow>
                <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                    <Box sx={{ height: 145 }}>
                        <NotFound />
                    </Box>
                </TableCell>
            </TableRow>
        ) : (
            data.map((row, index) => <RowComponent key={index} row={row} />)
        )}
    </>
);

const GlobalTable = ({ incData, decData }) => {
    const cols = ["نوع کالا", "حمل و نقل", "تغییرات قیمت", "تاریخ آخرین قیمت"];

    return (
        <TableContainer sx={{ overflow: "auto" }}>
            <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
                <TableHead>
                    <TableRow>
                        {cols.map((col) => (
                            <TableCell
                                key={col}
                                sx={{
                                    fontWeight: 700,
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {col}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Rows
                        title="بیشترین افزایش ماهانه"
                        color={COLORS.GREEN}
                        bgColor={COLORS.SOFTGREEN}
                        data={incData}
                        RowComponent={IncrementRow}
                    />
                    <Rows
                        title="بیشترین کاهش ماهانه"
                        color={COLORS.RED}
                        bgColor={COLORS.SOFTRED}
                        data={decData}
                        RowComponent={DecrementRow}
                    />
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default GlobalTable;
